<template>
  <div class="pagination-section scroller overflow-auto text-center thumbnail-area mt-20 addition-setting">
    <div class="mb-0 d-flex pagination-list list-unstyled overflow-auto align-items-center justify-content-center">
      <div
        v-show="!loader"
        :style="getDisplayValuesStyle"
        class="wrapper-audio-trim">
        <div
          class="audio-trim-left">{{ getStartDisplay }}
        </div>
        <div
          class="audio-trim-right">{{ getEndDisplay }}
        </div>
      </div>
      <div
        v-if="!isPlayed && !loader"
        class="play-btn"
        @click.stop="playAudio"
      >
        <icon name="playButton"/>
      </div>
      <div
        v-if="isPlayed && !loader"
        class="play-btn"
        @click.stop="pauseAudio"
      >
        <icon name="stop"/>
      </div>
      <div
        v-show="!loader"
        id="waveform"
        :style="getWaveFormStyle"/>
      <div class="d-flex">
        <div
          v-show="!loader"
          class="trim-btn"
          @click.stop="updateProductAudioDetails">DONE
        </div>
      </div>
    </div>
    <span
      v-if="!loader"
      class="d-flex display-duration">{{ getTotalActiveDurationOfAudio }}</span>
    <div v-show="loader">
      <Spinner
        v-show="loader"
        :speed="1"
        :message="getProgress"
        size="medium"
        class="inner-Loader"/>
    </div>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions';
import TimeLine from 'wavesurfer.js/dist/plugins/timeline';
import EnvelopePlugin from 'wavesurfer.js/dist/plugins/envelope';
import Spinner from 'vue-simple-spinner';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import EventBus from '@/EventBus';

export default {
  name:       'WaveSurferComponent',
  components: {
    Spinner,
  },
  props: {
    product: Object,
    width:   Number,
  },
  data() {
    return {
      waveSurfer:     null,
      startDisplay:   this.product.audioDetails.startTime,
      endDisplay:     this.product.audioDetails.endTime,
      progressTime:   0.0,
      totalDuration:  2,
      isPlayed:       false,
      activeRegion:   null,
      loader:         true,
      envelope:       null,
      progress:       0,
      audioStartTime: this.product.audioDetails.startTime,
      audioEndTime:   this.product.audioDetails.endTime,
      fadeInStart:    0,
      fadeInEnd:      this.product.audioDetails.fadeIn,
      fadeOutStart:   this.product.audioDetails.fadeOut,
      fadeOutEnd:     this.product.audioDetails.duration,
      isOptionsApply: false,
    };
  },
  computed: {
    getStartDisplay() {
      const totalSeconds = this.startDisplay;
      const minutes      = Math.floor(totalSeconds / 60);
      if (minutes > 0) {
        const seconds          = totalSeconds % 60;
        const formattedMinutes = (minutes < 10) ? minutes : minutes;
        const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
        console.log('formatted Seconds ', formattedSeconds);
        return `${formattedMinutes}:${formattedSeconds}`;
      }
      const seconds          = totalSeconds % 60;
      const formattedSeconds = (seconds < 10) ? seconds : seconds;
      return `${formattedSeconds.toFixed(1)}s`;
    },
    getEndDisplay() {
      const totalSeconds = this.endDisplay;
      const minutes      = Math.floor(totalSeconds / 60);
      if (minutes > 0) {
        const seconds          = totalSeconds % 60;
        const formattedMinutes = (minutes < 10) ? minutes : minutes;
        const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
        console.log('formatted Seconds ', formattedSeconds);
        return `${formattedMinutes}:${formattedSeconds}`;
      }
      const seconds          = totalSeconds % 60;
      const formattedSeconds = (seconds < 10) ? seconds : seconds;
      return `${formattedSeconds.toFixed(1)}s`;
    },
    getTotalActiveDurationOfAudio() {
      const totalDuration = ((this.product.audioDetails.duration - this.startDisplay) - (this.product.audioDetails.duration - this.endDisplay));
      const totalSeconds  = totalDuration;
      const minutes       = Math.floor(totalSeconds / 60);
      if (minutes > 0) {
        const seconds          = totalSeconds % 60;
        const formattedMinutes = (minutes < 10) ? minutes : minutes;
        const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
        return `${formattedMinutes}:${formattedSeconds}m`;
      }
      const seconds          = totalSeconds % 60;
      const formattedSeconds = (seconds < 10) ? seconds : seconds;
      return `${formattedSeconds.toFixed(1)}s`;
    },
    getProgress() {
      return `${this.progress}%`;
    },
    getWaveFormStyle() {
      const style = {
        width:        `${this.width - 150}px !important`,
        background:   'white',
        borderRadius: '16px',
        padding:      '5px',
      };
      return style;
    },
    getDisplayValuesStyle() {
      const style = {
        width: `${this.width - 150}px !important`,
      };
      return style;
    },
  },
  mounted() {
    this.createWaveform();
    EventBus.$on('updateFadeInAndFadeOutValues', this.updateFadeInAndFadeOutValues);
  },
  beforeDestroy() {
    if (this.waveSurfer) {
      this.waveSurfer.destroy();
    }
  },
  methods: {
    updateEnvelopePoints() {
      this.envelope.options.fadeInStart = this.startDisplay;
      this.envelope.setFadeInEnd(this.startDisplay + parseFloat(this.fadeInEnd));

      this.envelope.options.fadeOutEnd = this.endDisplay;
      this.envelope.setFadeOutStart(this.endDisplay - parseFloat(this.fadeOutStart));
    },
    updateFadeInAndFadeOutValues(fadeIn, fadeOut) {
      this.fadeInEnd    = fadeIn;
      this.fadeOutStart = fadeOut;
      this.envelope.setFadeInEnd(this.startDisplay + parseFloat(this.fadeInEnd));
      this.envelope.setFadeOutStart(parseFloat(this.endDisplay - this.fadeOutStart));
      this.isOptionsApply = true;
    },
    updateProductAudioDetails() {
      const audioDetails        = _.cloneDeep(this.product.audioDetails);
      audioDetails.startTime    = this.audioStartTime;
      audioDetails.endTime      = this.audioEndTime;
      audioDetails.fadeIn       = parseFloat(this.fadeInEnd);
      audioDetails.fadeOut      = this.isOptionsApply ? this.endDisplay - this.fadeOutStart : this.fadeOutStart;
      audioDetails.trimDuration = parseFloat(this.endDisplay).toFixed(1) - parseFloat(this.startDisplay).toFixed(1);
      EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioDetails);
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
      EventBus.$emit('unSelectAudioLayer');
      EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      this.isOptionsApply = false;
    },
    playAudio() {
      this.activeRegion.play();
      this.isPlayed = true;
    },
    pauseAudio() {
      this.waveSurfer.pause();
      this.isPlayed = false;
    },
    createWaveform() {
      this.waveSurfer = WaveSurfer.create({
        container:     '#waveform',
        height:        60,
        waveColor:     '#0092EE',
        progressColor: 'rgb(100, 0, 100)',
        cursorColor:   '#000000',
        cursorWidth:   3,
        barWidth:      2,
        barGap:        2,
        barRadius:     10,
        barHeight:     1,
        interact:      false,
        fillParent:    true,
        url:           this.product.audioDetails.audioUrl,
        sampleRate:    8000,
      });

      const wsRegions = this.waveSurfer.registerPlugin(RegionsPlugin.create());

      this.waveSurfer.on('decode', (e) => {
        this.activeRegion = wsRegions.addRegion({
          id:     'trim-audio',
          start:  this.product.audioDetails.startTime,
          end:    this.product.audioDetails.endTime,
          color:  'rgba(93,200,246,0.3)',
          drag:   true,
          resize: true,
        });

        this.activeRegion.on('update', () => {
          this.startDisplay = this.activeRegion.start;
          this.endDisplay   = this.activeRegion.end;
          EventBus.$emit('UpdateFadeInAndFadeOutMaxValue', parseFloat(this.endDisplay) - parseFloat(this.startDisplay));
          this.updateEnvelopePoints();
        });
      });

      this.envelope = this.waveSurfer.registerPlugin(
        EnvelopePlugin.create({
          id:              'region',
          fadeInStart:     this.product.audioDetails.startTime,
          fadeInEnd:       this.product.audioDetails.startTime + this.fadeInEnd,
          fadeOutStart:    this.product.audioDetails.fadeOut,
          fadeOutEnd:      this.product.audioDetails.endTime,
          lineColor:       'black',
          lineWidth:       1,
          dragPointSize:   0,
          dragPointFill:   'rgb(42,154,245)',
          dragPointStroke: 'rgb(255,255,255)',
        }),
      );


      this.envelope.on('fade-in-change', (fadeInEnd) => {
        console.log('fadeInEnd', fadeInEnd);
        this.fadeInEnd = fadeInEnd;
      });
      this.envelope.on('fade-out-change', (fadeOutStart) => {
        console.log('fadeOutStart', fadeOutStart);
        this.fadeOutStart = fadeOutStart;
      });

      this.waveSurfer.on('loading', (percent) => {
        this.progress = percent;
      });
      this.waveSurfer.on('ready', (duration) => {
        this.totalDuration = duration;
        console.log('Duration ', duration);
        this.loader = false;
      });
      wsRegions.on('region-updated', (region) => {
        this.activeRegion   = region;
        this.audioStartTime = region.start;
        this.audioEndTime   = region.end;
        this.isPlayed       = false;
        this.waveSurfer.pause();
      });

      this.waveSurfer.on('timeupdate', (currentTime) => {
        if (this.activeRegion && currentTime >= this.activeRegion.end) {
          this.waveSurfer.pause();
          this.isPlayed = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.display-duration{
  font-size: small;
  font-weight: bolder;
}
.wrapper-audio-trim{
  height: 10px;
  position: absolute;
  left: 50px;
  height: 130px;
  .audio-trim-left{
    position: absolute;
    left: 0;
    background: #3bb0fa;
    font-size: small;
    padding: 2px;
    width: 40px;
    border-radius: 12px
  }
  .audio-trim-right{
    position: absolute;
    right: 0;
    background: #3bb0fa;
    font-size: small;
    padding: 2px;
    width: 40px;
    border-radius: 12px
  }
}
.trim-btn{
  z-index: 10;
  margin-left: 10px;
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 0.1px solid #ADADAD;
  box-shadow: 0px 4px 50px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.play-btn{
  left: 0px;
  position: absolute;
  z-index: 11;
  margin-left: 10px;
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border-radius: 50%;
  border: 0.1px solid #ADADAD;
  box-shadow: 0px 4px 50px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.pagination-section{

  .pagination-pill {
    @include FontVariation(1.2rem,600,Open Sans,$grey70);
    line-height: 2.0rem;
    min-width: 28px;
    height: 28px;
    cursor: pointer;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);

    &:hover {
      color: $grey90 !important;
    }

    &:active {
      color: $blue50;
    }

    &:disabled {
      cursor: default !important;
      pointer-events: none;
      color: $grey40;
      &:hover{
        color: $grey40 !important;
      }
    }
  }
  &.thumbnail-area{
    height: 120px;
    z-index: 1;
    .pagination-button-wrapper{
      width: 120px;
      height: 84px;
      text-align: center;
      background-color: #D6D6D6;
      display: flex;
      align-items: center;
      justify-content: center;
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4), 0px 0px 2px rgba(0, 0, 0,  0.6), 0px 0px 1px rgba(0, 0, 0,  0.4);
      border-radius: 7px;

      .pagination-pill{
        box-shadow: none

      }
      &.page-plus{
        width: 78px;
        background-color: #D6D6D6;
        box-shadow: none;

        .pagination-pill{
          background-color: transparent;
        }
      }
    }
  }

}
.addition-setting{
  margin-left: 14px;
}
#waveform ::part(cursor) {
  height: 100px;
  border-radius: 8px;
}
#waveform ::part(trim-audio) {
  font-size: 22px;
  border-radius: 8px;
  color: #000000;
}
#waveform ::part(region) {
  border-radius: 8px;
  height: 100% !important;
}
#waveform ::part(line) {
  pointer-events: none !important;
}
#waveform ::part(region-handle-right) {
  border-right-width: 8px !important;
  border-radius: 8px;
  border-right-color: #00a6f5 !important;
}
#waveform ::part(region-handle-left) {
  border-left-width: 8px !important;
  border-radius: 8px;
  border-left-color: #00a6f5 !important;
}
</style>
